const updateGridFieldList = crm => async ({ fieldName, subscriber, dispatchWrapper, getState }) => {
	const { data } = getState();
	const recs = data[fieldName] || [];
	dispatchWrapper("handleFormChange", [subscriber, "Int", recs]);
};

export default updateGridFieldList;
